/**
 * Full-page navigation helper. This is an abstract token with a platform-specific implementation:
 *
 * - Web (`LocationServiceWeb`): reloads via the browser (`window.location.reload()`).
 * - Desktop (`LocationServiceDta`): reloads through the Electron main process (`IPC.RELOAD` ->
 *   `mainWindow.reload()`) so the reload is owned by the window that loaded the app rather than
 *   just the renderer document.
 *
 * Consumers inject `LocationService`; the bootstrap for each target binds the concrete class.
 */
export abstract class LocationService {
  redirect(url: string): void {
    window.location.replace(url);
  }

  abstract reloadPage(): void;
}
